import { Nil } from "cy-util";
import { cn } from "cy-fe/src/utils/cn";
import { PhoneCountryCode } from "./phoneCountryCodes";

export function comboBoxButtonContent(
  size: string,
  value: PhoneCountryCode | Nil,
) {
  const large = size === "lg";
  return (
    <div className="flex h-full items-center">
      <span className={cn("font-semibold", "text-sm", large && "text-base")}>
        {value?.prefix}
      </span>
    </div>
  );
}
